import { alpha, Box, Container, Stack, useMediaQuery } from '@mui/material';
import type { ReactNode } from 'react';
import BayerLookup from '../lookup';
import cornPlants from './assets/backgrounds/corn-plants.png';
import expertobayer from './assets/backgrounds/experto-bayer-hero.png';
import fieldviewBackground from './assets/backgrounds/fieldview.png';
import bayer from './assets/logos/bayer.svg';
import expertobayerWhite from './assets/logos/experto-bayer-white.svg';
import fieldviewLogo from './assets/logos/fieldview.svg';

const appHeroBackgrounds = {
    fieldview: fieldviewBackground,
    expertobayer: expertobayer,
    cornPlants: cornPlants,
};

export const pdfHeroLogos = {
    expertobayer: expertobayerWhite,
    bayer: bayer,
    fieldview: fieldviewLogo,
};

const HeroHeader = ({
    title,
    body,
    background,
    maxWidth = 'xl',
    actions,
    titleIcon,
    isFieldview = false,
}: {
    title: string;
    body: string;
    background: keyof typeof appHeroBackgrounds;
    maxWidth?: string;
    actions?: ReactNode;
    titleIcon?: ReactNode;
    isFieldview?: boolean;
}) => {
    const isMobile = useMediaQuery((theme) => (theme ? theme.breakpoints.down('sm') : false));

    return (
        <Box
            sx={{
                display: 'flex',
                color: '#fff',
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: isFieldview ? '#271B12' : 'primary.main',
                backgroundPosition: 'bottom',
            }}
            py={{ xs: 4, sm: 8 }}
        >
            {!isMobile && (
                <>
                    <Box
                        sx={{
                            position: 'absolute',
                            justifySelf: 'end',
                            inset: 0,
                            width: '100%',
                            // left solid block with diagonal cut
                            zIndex: 1,
                            //
                            backgroundSize: 'cover',
                            backgroundImage: `url(${appHeroBackgrounds[isFieldview ? 'fieldview' : background]})`,
                            backgroundPosition: 'bottom',
                        }}
                    />

                    {/* Solid block with angled cut */}
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: (t) => alpha(isFieldview ? '#271B12' : t.palette.primary.main, 0.95),
                            clipPath: 'polygon(0 0, 30% 0, 25% 100%, 0 100%)',
                            // left solid block with diagonal cut
                            zIndex: 1,
                        }}
                    />

                    {/* Semi transparent  block with angled cut */}
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: (t) => alpha(isFieldview ? '#271B12' : t.palette.primary.main, 0.93),
                            clipPath: 'polygon(0 0, 58% 0, 52% 100%, 0 100%)',
                            // left solid block with diagonal cut
                            zIndex: 1,
                        }}
                    />
                </>
            )}

            <Container
                maxWidth={maxWidth}
                sx={{
                    zIndex: 2,
                }}
            >
                <Stack direction='row' justifyContent='space-between'>
                    <BayerLookup
                        sx={{
                            maxWidth: isMobile ? '100%' : '50%',
                            justifyContent: 'center',
                        }}
                        color='white'
                        title={title}
                        body={body}
                        titleIcon={titleIcon}
                    />
                    {actions && actions}
                </Stack>
            </Container>
        </Box>
    );
};

export default HeroHeader;
